import { useState } from 'react';
import { Fingerprint, LogOut } from 'lucide-react';
import { brand } from '@app/shared/brand';
import { useSession } from '../platform/session.tsx';
import { Banner, Button } from '../ui/index.ts';

/** Shown instead of the app while the device app lock is engaged. */
export function LockScreen({ unlock }: { unlock(): Promise<boolean> }) {
  const { signOut, me } = useSession();
  const [failed, setFailed] = useState(false);
  return (
    <main className="auth-page">
      <div className="ui-card auth-card" style={{ textAlign: 'center', justifyItems: 'center' }}>
        <img src={brand.icons.svg} alt="" width={64} height={64} style={{ borderRadius: 18 }} />
        <h1>Locked</h1>
        <p className="muted">{me?.user.displayName ? `${me.user.displayName}, unlock` : 'Unlock'} with your device's fingerprint, face or PIN.</p>
        {failed && <Banner tone="warning">That didn't work. Try again, or sign out.</Banner>}
        <Button variant="primary" size="lg" block autoFocus icon={<Fingerprint aria-hidden="true" />} onClick={async () => setFailed(!(await unlock()))}>
          Unlock
        </Button>
        <Button variant="ghost" icon={<LogOut aria-hidden="true" />} onClick={() => void signOut()}>
          Sign out instead
        </Button>
      </div>
    </main>
  );
}
